import {CanalNotificationWithMessageCountDto, INotificationsWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class EnregistrementCanalResolver implements Resolve<CanalNotificationWithMessageCountDto> {

  constructor(private notificationsWebService: INotificationsWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let id = route.params['id'];
    return this.notificationsWebService.getCanalNotification(id);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/canaux/enregistrement/enregistrement.canaux.resolver.ts